import DashboardIncidentCriticalActionsBreakdownCard from './DashboardIncidentCriticalActionsBreakdownCard';

export default DashboardIncidentCriticalActionsBreakdownCard;
